import { useState, useEffect } from 'react';
import './App.css';

// Components
import { Cursor } from './components/layout/Cursor';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { Hero } from './components/sections/Hero';
import { About } from './components/sections/About';
import { Process } from './components/sections/Process';
import { Services } from './components/sections/Services';
import { Apps } from './components/sections/Apps';
// import { Store } from './components/sections/Store';
import { Jobs } from './components/sections/Jobs';
import { Team } from './components/sections/Team';
import { Reviews } from './components/sections/Reviews';
import { Contact } from './components/sections/Contact';
import { JobModal } from './components/modals/JobModal';
import { ProductModal } from './components/modals/ProductModal';
import { TermsModal } from './components/modals/TermsModal';
import { ChatWidget } from './components/chat/ChatWidget';

// Hooks
import { useCursor } from './hooks/useCursor';
import { useChat } from './hooks/useChat';

// Utils
import { injectSEO, preventDevTools } from './utils/seo';
import { scrollToHash } from './utils/helpers';

function App() {
  // State
  const [gone, setGone] = useState(false);
  const [up, setUp] = useState(false);
  const [bar, setBar] = useState(false);
  const [navVis, setNavVis] = useState(false);
  const [heroIn, setHeroIn] = useState(false);
  const [menu, setMenu] = useState(false);
  const [activeJob, setActiveJob] = useState(null);
  const [activeProduct, setActiveProduct] = useState(null);
  const [termsOpen, setTermsOpen] = useState(false);

  // Hooks
  const { cur, hov, active } = useCursor();
  const chat = useChat();

  // Intro animation
  useEffect(() => {
    const t1 = setTimeout(() => setUp(true), 200);
    const t2 = setTimeout(() => setBar(true), 900);
    const t3 = setTimeout(() => {
      setGone(true);
      setNavVis(true);
      setHeroIn(true);
    }, 2600);
    return () => [t1, t2, t3].forEach(clearTimeout);
  }, []);

  // SEO
  useEffect(() => {
    injectSEO();
    const cleanup = preventDevTools();
    return cleanup;
  }, []);

  // Handle hash routing
  useEffect(() => {
    if (window.location.hash) {
      scrollToHash(window.location.hash);
    }
  }, [gone]);

  // Close mobile menu on resize
  useEffect(() => {
    const h = () => { if (window.innerWidth > 768) setMenu(false); };
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  return (
    <div className={`ns${active ? " cursor-active" : ""}`}>
      {/* Cursor */}
      <Cursor cur={cur} hov={hov} active={active} />

      {/* Intro */}
      <div className={`intro${gone ? " gone" : ""}`}>
        <div className="intro-row">
          {[...'Nismay'].map((c, i) => (
            <span key={i} className={`ic w${up ? " up" : ""}`} style={{ transitionDelay: `${i * 0.065}s` }}>{c}</span>
          ))}
        </div>
        <div className="intro-row">
          {[...'Studios'].map((c, i) => (
            <span key={i} className={`ic r${up ? " up" : ""}`} style={{ transitionDelay: `${0.42 + i * 0.06}s` }}>{c}</span>
          ))}
        </div>
        <div className={`ibar${bar ? " grow" : ""}`} />
      </div>

      {/* Layout */}
      <Navbar navVis={navVis} menu={menu} setMenu={setMenu} />
      <Hero heroIn={heroIn} />
      <About />
      <Process />
      {/* <Store onProductClick={setActiveProduct} /> */}
      <Services />
      <Apps />
      {/* <Jobs onJobClick={setActiveJob} /> */}
      <Team />
      <Reviews />
      <Contact />
      <Footer onTermsOpen={() => setTermsOpen(true)} />

      {/* Modals */}
      <JobModal job={activeJob} onClose={() => setActiveJob(null)} />
      <ProductModal product={activeProduct} onClose={() => setActiveProduct(null)} />
      <TermsModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} />

      {/* Chat */}
      <ChatWidget
        chatOpen={chat.chatOpen}
        setChatOpen={chat.setChatOpen}
        chatMsgs={chat.chatMsgs}
        chatInput={chat.chatInput}
        setChatInput={chat.setChatInput}
        chatLoading={chat.chatLoading}
        chatBodyRef={chat.chatBodyRef}
        sendChatMessage={chat.sendChatMessage}
        suggestions={chat.CHAT_SUGGESTIONS}
      />
    </div>
  );
}

export default App;